import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  customConvertIntoSelect2OptionsClasses,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const ManageChat = () => {
  const teacherId = localStorage.getItem("userId");
  const [challengeOptions, setChallengeOptions] = useState([]);
  const [reportedMessages, setReportedMessages] = useState([]);

  const breadcrumb = {
    current_section: "Chat",
    sections: [
      { name: "Gestione Punti", route_name: null, params: [] },
      { name: "Chat", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchChallenges = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getAllChallenges?schoolId=${localStorage.getItem(
            "userSchoolId"
          )}&teacherId=${teacherId}`,
          fetchOptions
        );
        const result = await response.json();
        setChallengeOptions(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchChallenges();
  }, []);

  useEffect(() => {
    if (challengeOptions.length > 0) {
      const fetchReportedMessages = async () => {
        try {
          const fetchOptions = getFetchOptions(
            "application/json",
            { challengeIds: challengeOptions.map((challenge) => challenge.id) },
            "POST"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/fe/getReportedMessages`,
            fetchOptions
          );
          const result = await response.json();
          setReportedMessages(result);
        } catch (error) {
          console.error(error);
        }
      };

      fetchReportedMessages();
    }
  }, [challengeOptions]);

  const handleDeleteMessage = async (message) => {
    try {
      const fetchOptions = getFetchOptions("application/json", [], "DELETE");
      await fetch(
        `${axios.defaults.baseBFFUrl}/fe/deleteReportedMessage?messageId=${message.id}`,
        fetchOptions
      );

      const fetchReportedMessages = async () => {
        try {
          const fetchOptions = getFetchOptions(
            "application/json",
            { challengeIds: challengeOptions.map((option) => option.value) },
            "POST"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/fe/getReportedMessages`,
            fetchOptions
          );
          const result = await response.json();
          setReportedMessages(result);
        } catch (error) {
          console.error(error);
        }
      };

      fetchReportedMessages();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      {/* Message List */}
      <div className="card custom-card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>Elenco Messaggi Segnalati</div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Mittente</th>
                  <th>Conversazione</th>
                  <th>Messaggio</th>
                  <th>Data Segnalazione</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {reportedMessages?.length > 0 ? (
                  reportedMessages.map((message) => (
                    <tr key={message.id}>
                      <td>
                        {message.Student?.nome + " " + message.Student?.cognome}
                      </td>
                      <td>{message.Conversation?.name}</td>
                      <td>{message.message_text}</td>
                      <td>{new Date(message.report_date).toLocaleString()}</td>
                      <td>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleDeleteMessage(message)}
                        >
                          Elimina
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      Nessun dato disponibile
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageChat;
